export const formatNumber = (num = 0) => {
  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 8,
  }).format;
  return formatter(num);
};

export const toNumber = (value: string) => Number(value.replaceAll(',', ''));
